import * as React from 'react';
import { observer } from 'mobx-react';
import { ReactComponent as PrevIcon } from '../../assets/icons/reports/prev-icon.svg';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AccessStore } from '../../store/Access';
import './BackArrowStyles.scss';
import { useAnalytics } from '../../utils/hooks';

export interface BackArrowI{
  text: string,
  reportType: 'Org' | 'Dep' | 'Sector' | 'Project'
}

export const BackArrow = observer((props: BackArrowI)=>{
  const navigate = useNavigate();
  const {itemsLength} = AccessStore;
  const {t} = useTranslation();
  const renderIcon = (itemsLength > 1);
  return(
    <div className={'navigation'}>
      {renderIcon && <PrevIcon style={{marginRight:'16px'}} onClick={() => {
        useAnalytics('Reports', 'back_from_report', props.reportType );
        navigate(-1);
      }} />}
      <h2>{t(props.text)}</h2>
    </div>
  );
});
